import useRequest from 'core/hooks/useRequest';
import { bebop as bebopApi } from 'core/api/definitions/bebop';

import { getPuidsLink } from 'core/utils/url-helper';

import { VOID_QUERY } from 'core/site/constants';

const fallbackRef = {};

/**
 * Возвращает пуиды, запрошенные из апи, или те, что переданы вторым аргументом
 *
 * @param {string} pathname урл, для которого нужны пуиды
 * @param {*} puids пуиды, которые следует вернуть вместо запроса из апи
 * @returns {Object}
 */
export default function usePuids(pathname, externalPuids) {
  const queryParams = externalPuids || !pathname
    ? VOID_QUERY
    : {
      queryKey: ['bebopApi', 'getPuids', {
        puid_link: getPuidsLink(pathname),
      }],
      queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params),
    };
  const {
    data: puids = externalPuids,
  } = useRequest(queryParams);

  if (!pathname && !puids) console.warn('[usePuids]: missing pathname, returning empty object');

  return puids || fallbackRef;
}
